export const KeyDetails = {
    fullBaths: 'fullBaths',
    businessOpportunity: 'chimeBusinessName',
    purchaseType: 'purchaseType',
    halfBaths: 'halfBaths',
    specialSale: 'specialListingCondition',
    constructionStatus: 'chimeConstructionStatus',
    membershipFee: 'chimeMinMembershipAmount',
    listingStatus: 'listingStatus',
    style: 'style',
    membershipFeeRequired: 'chimeMembershipFeeRequired',
    mlsListingId: 'mlsListingId',
    financing: 'chimeFinancingBuyer',
    soldDate: 'Sold Date',
    hoaFees: function() {
        //todo
        return '';
    },
    shortSale: 'shortSales',
    soldPrice: 'soldPrice',
    price: 'priceStr',
    buildingAge: 'chimeBuildingAgeDesc',
    pricePerSqft: function(info) {
        if (info.soldPrice != '-1' && info.sqft) {
            return info.soldPrice / info.sqft;
        }
        if (info.price && info.sqft) {
            return info.price / info.sqft;
        }
        return 0;
    },
    condoFees: function(info) {
        //todo
        return '';
    },
    propertyType: 'propertyType',
    unitFloor: 'chimeUnitFloorNum',
    landTenure: 'landTenure',
    subdivision: 'subDivisionName',
    commonCharge: 'chimeCommonCharge',
    lotSize: 'totalAvailableAcres',
    totalUnits: 'chimeNumOfUnits',
    maintenanceCommonCharge: 'chimeMaintCommonChargeFee',
    terms: 'terms',
    maintenanceFees: 'chimeMaintenanceFee',
    yearBuilt: 'builtYear'
};
export const Location = {
    county: 'county',
    zoning: 'zoningType',
    community: 'community',
    direction: 'chimeDirection',
    area: 'chimeArea',
    locationDetails: 'chimeLocationDetails',
    areaMajor: 'citySecondary',
    buildingComlexName: 'chimeComplex',
    region: 'chimeRegion',
    bedroomDescription: 'chimeBedroomDescription',
    bodyOfWater: 'chimeWaterBody',
    state: 'state'
};
export const Interior = {
    plumbing: 'plumbing',
    mainFullBath: 'chimeMainFullBath',
    heating: 'heating',
    mainHalfBath: 'chimeMainHalfBath',
    appliance: 'chimeAppliance',
    style: 'styles',
    cooling: 'cooling',
    upperFullBath: 'chimeUpperFullBath',
    dryerUtilities: 'chimeDryerUtilities',
    flooring: 'flooring',
    upperHalfBath: 'chimeUpperHalfBath',
    laundry: 'laundry',
    fireplacesNumber: 'fireplacesNumber',
    furnishings: 'furnishedDescription',
    interiorFeatures: 'interiorFeatures',
    lowerFullBath: 'chimeLowerFullBath',
    fireplacesType: 'fireplacesType',
    windowFeatures: 'chimeWindows',
    laundryLocation: 'chimeLaundry',
    lowerHalfBath: 'chimeLowerHalfBath',
    inclusions: 'inclusions',
    steps: 'chimeSteps',
    kitchenAppliances: 'chimeAppilances',
    fireplace: 'chimeFireplaceFlag',
    hotWater: 'hotWater',
    equipment: 'equipment',
    fireplaceLocation: 'chimeFireplaceLocation'
};
export const Exterior = {
    parkingType: 'chimeParkingType',
    waterAccess: 'waterAccessFlag',
    garage: 'garageDescription',
    landscapeDescription: 'chimeLandscapeDescription',
    roofType: 'roofType',
    attachedGarage: 'chimeAttachedGarage',
    garageSpaces: 'garageParkingSpaces',
    waterView: 'viewFlag',
    presentUse: 'chimePresentUse',
    garageDescription: 'garageSpaceDescription',
    improvements: 'chimeImprovements',
    communityFeatures: 'communityFeatures',
    topography: 'chimeTopography',
    parkingOnSite: 'parkingOnSite',
    streetSurface: 'chimeStreetSurface',
    accessibility: 'chimeAccessibility',
    view: 'view',
    fence: 'fence',
    farm: 'chimeFarmDescription',
    handicapAccess: 'chimeHandicapAccess',
    complexFeatures: 'complexFeatures',
    amenitiesAvailable: 'chimeAmenities',
    pool: 'pool',
    porch: 'chimePorchType',
    utilitiesAvailable: 'utilities',
    exteriorFeature: 'exterior',
    waterfrontDescription: 'waterfrontDescription',
    roadFrontage: 'chimeRoadFrontage',
    waterfront: 'waterfrontFlag',
    carportSpaces: 'chimeCarportSpace',
    lotDescription: 'lotDescription',
    waterAccessDesc: 'waterAccess',
    lotFront: 'chimeLotFront'
};
export const Building = {
    aboveGroundFinishedSqft: 'chimeAboveGroundSqft',
    lotDescription: 'lotDescription',
    faces: 'chimeHouseFaces',
    warranty: 'chimeWarranty',
    unitFeatures: 'chimeUnitFeatures',
    foundation: 'foundation',
    levels: 'chimeUnitLevel',
    unitLocation: 'chimeUnitLocation',
    '1stLevelFloorPlan': 'chimeFloorPlanLevel1',
    story: 'stories',
    builderName: 'chimeBuilderName',
    lotDimensions: 'chimeLotDimensions',
    '2ndLevelFloorPlan': 'chimeFloorPlanLevel2',
    undergroundSqft: 'undergroundSqft',
    lotSizeRange: 'chimeAcreageRange',
    sewer: 'sewageType',
    '3rdLevelFloorPlan': 'chimeFloorPlanLevel3',
    newConstruction: 'newConstructionFlag',
    assessorPlat: 'assessorPlat',
    water: 'exitingWater',
    dwellingType: 'dwellingType',
    assessorLot: 'assessorLot',
    architecturalStyle: 'chimeArchitecturalStyle',
    buildingDescription: 'chimeExteriorBuildingType'
};
export const School = {
    middleSchools: 'middleSchool',
    highSchoolBus: 'chimeHighSchoolBusFlag',
    highSchools: 'highSchool',
    schoolDistrict: 'schoolDistrict',
    elementarySchoolBus: 'chimeElementarySchoolBusFlag',
    middleSchoolBus: 'chimeMiddleSchoolBusFlag',
    elementarySchools: 'elementarySchool'
};
export const Rooms = {
    numOfLiving: 'chimeLivingNum',
    'bedroom+': 'chimeBedroomsPlus',
    basement: 'basementType',
    extraRoom1: function() {
        //todo
        return '';
    },
    roomsInfo: 'roomResourceInfo',
    guestAccommodations: 'chimeGuestHouse',
    bedroom2: function() {
        //todo
        return '';
    },
    extraRoom2: function() {
        //todo
        return '';
    },
    basementNum: 'basementNum',
    masterDescription: 'chimeMasterDescription',
    bedroom3: function() {
        //todo
        return '';
    },
    roomsLevel: 'chimeSpecialSearch',
    extraRoom3: function() {
        //todo
        return '';
    },
    basementEntrance: 'basementEntrance',
    masterBathroom: 'chimeMasterBathDesc',
    bedroom4: function() {
        //todo
        return '';
    },
    masterBedroom: function() {
        //todo
        return '';
    },
    extraRoom4: function() {
        //todo
        return '';
    },
    bedroom5: function() {
        //todo
        return '';
    },
    extraRoom5: function() {
        //todo
        return '';
    },
    livingRoom: function() {
        //todo
        return '';
    },
    extraRoom6: function() {
        //todo
        return '';
    },
    familyRoom: 'familyRoom',
    bedroomDescription: 'chimeBedroomDescription',
    masterBath: 'chimeMasterBedroomBath',
    diningRoom: function() {
        //todo
        return '';
    },
    otherRooms: 'otherRooms',
    masterBedroomLevel: 'mbrLevel',
    numOfDining: 'chimeDiningNum',
    mainLevelBedrooms: 'chimeMainLevelBedrooms',
    kitchen: function() {
        //todo
        return '';
    }
};
export const Others = {
    restrictions: 'chimeRestrictions',
    energyFeature: 'chimeEnergyFeature',
    taxYear: 'taxYear',
    petSize: 'chimePetSize',
    taxId: 'chimeTaxID',
    taxRate: 'chimeTaxRate',
    assessmentAmount: 'assessmentAmount',
    sqftSource: 'chimeSquareFootSource',
    ownership: 'ownerShip',
    disablilityFeatures: 'chimeDisabilityFeaturesDesc',
    monthlyTotalFees: 'monthlyTotalFees',
    acceptableFinancing: 'listingTerms',
    petsAllowed: 'petsDescription',
    miscellaneous: 'miscellaneous',
    rebuiltYear: 'chimeRebuiltYear',
    ageRestriction: 'ageRestriction',
    securityFeatures: 'chimeSecurityFeature',
    recentlyRenovated: 'chimeRecentlyRenovated',
    hoaName: 'chimeAssociationName',
    energyDescription: 'chimeFuel',
    membershipFeeRequired: 'chimeMembershipFeeRequired',
    associationRules: 'chimeAssocRules',
    lastPrice: 'oldValue',
    buildableLand: 'chimeBuildableLandFlag',
    hoaFeeInclude: 'chimeAssociationFeeInclude',
    seniorCommunity: 'adultCommunity',
    horseProperty: 'chimeHorseProperty',
    taxAmount: 'taxAmount',
    virtualTour2: 'chimeVirtualTour2'
};
export const MultiUnitInfo = {
    multiUnitInformation: 'otherInfo'
};
